import api from './api';

export interface TesoreriaCarterasDetRow {
  nroFormulario?: number | null;
  fechaEmision?: string | null;
  descripcion?: string | null;
  letra?: string | null;
  nroSuc?: number | null;
  nroComprobante?: number | null;
  nroBanco?: number | null;
  nombreBanco?: string | null;
  tipoDeCuenta?: string | null;
  nroDeCuenta?: string | null;
  debe?: number | null;
  haber?: number | null;
  nroTipoPago?: number | null;
}

export interface TesoreriaCarterasDetResponse {
  data: TesoreriaCarterasDetRow[];
  totalMatched: number;
  truncated: boolean;
}

export interface GetRptCarterasDetParams {
  fechaDesde: string;
  fechaHasta: string;
  nroBanco?: number;
  nroTipoFormulario?: string;
  nroSuc?: number;
  maxRows?: number;
}

const tesoreriaInformesService = {
  getRptCarterasDet: async (params: GetRptCarterasDetParams): Promise<TesoreriaCarterasDetResponse> => {
    const query = new URLSearchParams();
    query.append('fechaDesde', params.fechaDesde);
    query.append('fechaHasta', params.fechaHasta);
    if (params.nroBanco != null) query.append('nroBanco', String(params.nroBanco));
    if (params.nroTipoFormulario?.trim()) query.append('nroTipoFormulario', params.nroTipoFormulario.trim());
    if (params.nroSuc != null) query.append('nroSuc', String(params.nroSuc));
    if (params.maxRows != null) query.append('maxRows', String(params.maxRows));

    const response = await api.get<TesoreriaCarterasDetResponse>(
      `/api/TesoreriaInformes/rpt-carteras-det?${query.toString()}`,
    );
    return response.data;
  },
};

export default tesoreriaInformesService;
